import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



  const cardData =
  {
    keyword: 'Best Cab Services in Pune',
    heading: 'Aaryan Travels: Best Cab Services in Pune',
    headingDescription: ' Aaryan Travels is proudly recognized among the Best Cab Services in Pune, offering safe, punctual, and affordable travel solutions for both local and outstation journeys. Whether you’re planning an airport transfer, a family trip, a corporate ride, or daily city commuting, our diverse fleet of hatchbacks, sedans, SUVs, luxury cars, and tempo travellers ensures maximum comfort and convenience. With professional chauffeurs, clean vehicles, and transparent pricing, we make every ride smooth and stress-free. From Hinjewadi IT Park to Wagholi, Kothrud to Kharadi, Aaryan Travels covers every corner of Pune with reliable 24/7 cab services tailored to your needs.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

    "topPlaces": [
      {
        "title": "Shaniwar Wada",
        "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
      },
      {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
      },
      {
        "title": "Sinhagad Fort",
        "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
      },
      {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
      },
      {
        "title": "Pataleshwar Cave Temple",
        "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
      },
      {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
      },
      {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
      },
      {
        "title": "Osho Ashram",
        "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
      },
      {
        "title": "Pu La Deshpande Garden",
        "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
      },
      {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
      }
    ],


    "services": [
  {
    "name": "Best Cab Services in Pune",
    "description": "Discover the Best Cab Services in Pune that combine punctuality, comfort, and affordability. Our fleet includes modern, well-maintained vehicles driven by experienced professionals who prioritize your safety and convenience. Whether you need a quick ride across town or a reliable transfer to the airport, our service ensures seamless travel with real-time tracking, 24/7 availability, and easy booking options. Enjoy stress-free journeys backed by excellent customer support and transparent pricing designed to suit all your transportation needs."
  },
  {
    "name": "Top Cab Companies Pune",
    "description": "Connect with the Top Cab Companies in Pune known for their commitment to quality and customer satisfaction. These companies offer a diverse range of vehicle options, from compact sedans to luxury SUVs, tailored for individual riders and corporate clients alike. Benefit from professional drivers, safe routes, and prompt service that make every trip enjoyable. Whether you’re commuting for work, attending events, or exploring Pune, the top cab companies ensure reliability, competitive pricing, and hassle-free booking through both app and call options."
  },
  {
    "name": "Affordable Cab Pune",
    "description": "Choose Affordable Cab services in Pune without compromising on safety or comfort. Perfect for daily commuters, students, and budget-conscious travelers, these cabs provide excellent value through transparent fare structures and no hidden charges. Enjoy rides in clean, well-maintained vehicles operated by courteous drivers who know the city well. From short intra-city trips to longer rides, Affordable Cab Pune offers convenient booking methods and timely service to keep your travels smooth and pocket-friendly."
  },
  {
    "name": "Reliable Taxi Service Pune",
    "description": "Rely on the Reliable Taxi Service in Pune for timely pickups, safe travel, and professional drivers who understand your urgency and requirements. This service caters to diverse needs—office commutes, airport transfers, and leisure trips—with a focus on punctuality and customer comfort. With GPS-enabled cabs and real-time updates, you can track your ride effortlessly. Enjoy round-the-clock availability and hassle-free cancellations or modifications, making it the preferred choice for individuals and businesses alike."
  },
  {
    "name": "Cab Booking Pune",
    "description": "Book your cab in Pune with ease through intuitive digital platforms or quick phone reservations. Cab Booking Pune services streamline your travel planning by offering instant confirmations, flexible payment options including digital wallets and cards, and multiple vehicle categories to fit your needs. Whether you want a standard sedan, an SUV for group travel, or a luxury car for special occasions, the service ensures competitive pricing, courteous drivers, and reliable rides. Save time and avoid waiting with pre-scheduled pickups and on-demand cab availability."
  },
  {
    "name": "Local Taxi Service Pune",
    "description": "Navigate the bustling streets of Pune with our Local Taxi Service designed for short-distance travel. Ideal for daily errands, shopping trips, and quick office commutes, this service offers affordable rates and prompt pickups within city limits. Drivers are familiar with all local routes, helping you avoid traffic snarls and reach your destination efficiently. Available 24x7, Local Taxi Service Pune is a convenient and dependable choice for residents and visitors alike."
  },
  {
    "name": "Outstation Cab Pune",
    "description": "Plan your intercity journeys with Outstation Cab services from Pune, perfect for business trips, family outings, or weekend getaways. Offering a variety of vehicles, including sedans and SUVs, these cabs ensure comfortable and safe travel over longer distances. Enjoy flexible packages with options for one-way trips, round trips, or multi-day rentals. Drivers are experienced with highways and routes beyond Pune, guaranteeing smooth rides with timely stops and clear communication. Book your Outstation Cab with confidence and ease."
  },
  {
    "name": "Premium Cab Services Pune",
    "description": "Experience luxury and exclusivity with Premium Cab Services in Pune. Ideal for corporate clients, special events, or anyone seeking top-tier transportation, these services feature high-end vehicles such as luxury sedans, SUVs, and executive vans. Chauffeurs are professionally trained, ensuring discreet, safe, and comfortable rides with attention to detail. Enjoy perks like onboard Wi-Fi, bottled water, and customized routes. Premium Cab Services combine sophistication with reliability for travelers who demand the best."
  },
  {
    "name": "Trusted Cab Pune",
    "description": "Rely on Trusted Cab services in Pune that have built a reputation through consistent quality, safety, and customer satisfaction. Every vehicle undergoes regular maintenance, and drivers are thoroughly vetted and trained. This trustworthiness extends to transparent fare policies, on-time service, and responsive customer support. Whether for daily commutes, airport runs, or emergency travel, Trusted Cab Pune prioritizes your peace of mind and comfort throughout your journey."
  },
  {
    "name": "24x7 Cab Services Pune",
    "description": "Avail 24x7 Cab Services in Pune for uninterrupted transportation whenever you need it, day or night. Perfect for shift workers, late-night travelers, or early morning flights, these cabs operate round the clock with prompt dispatch and quick response times. Drivers are equipped with navigation tools to provide the fastest routes, ensuring you never miss appointments or flights. With easy booking via phone or app and cashless payment options, 24x7 Cab Services offer convenience and peace of mind for all your travel needs."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Simplify your travel with Online Cab Booking in Pune, offering user-friendly apps and websites that make scheduling rides quick and hassle-free. Secure your ride in advance or book on-demand with instant confirmations and transparent fare estimates. Benefit from digital payments, real-time ride tracking, and customer support at your fingertips. Whether commuting, attending events, or traveling for business, Online Cab Booking Pune ensures reliability, safety, and convenience tailored to your schedule."
  },
  {
    "name": "Fast Cab Service Pune",
    "description": "Choose Fast Cab Service in Pune for swift pickups and minimal waiting times. Ideal for last-minute travel needs, urgent meetings, or quick errands, this service emphasizes speed without sacrificing safety or comfort. Using an extensive network of vehicles and advanced dispatch systems, Fast Cab Service Pune ensures you’re on the move promptly. Track your cab live, communicate with drivers, and enjoy a smooth ride that respects your tight schedules and busy lifestyle."
  },
  {
    "name": "Pune Taxi Near Me",
    "description": "Find the nearest available Pune Taxi Near Me quickly and effortlessly with location-based services that connect you to nearby cabs. Reduce wait times and enjoy timely pickups whether you’re at home, work, or a public spot. This service leverages GPS technology to match you with the closest drivers, offering competitive fares and verified vehicles. Ideal for spontaneous travel needs, Pune Taxi Near Me ensures you’re never far from reliable transportation."
  },
  {
    "name": "Budget Cab Pune",
    "description": "Travel smart with Budget Cab services in Pune that offer cost-effective solutions for everyday transportation. Designed for students, daily commuters, and price-conscious travelers, these cabs provide safe, clean vehicles at low fares without hidden costs. Enjoy easy booking, punctual service, and courteous drivers who prioritize your comfort. Budget Cab Pune is the perfect balance of affordability and quality for all your local travel requirements."
  },
  {
    "name": "Comfortable Cab Pune",
    "description": "Relax and enjoy every ride with Comfortable Cab services in Pune, focusing on spacious interiors, smooth rides, and attentive drivers. Ideal for family trips, long-distance travel, or special occasions, these cabs provide air-conditioning, clean upholstery, and extra legroom for a premium experience. Drivers prioritize safety and courteous service, ensuring a pleasant journey whether you’re heading to the airport, business meetings, or leisure outings around the city."
  }
],
"tableData": [
  ["Best Cab Services in Pune", "Top Cab Companies Pune"],
  ["Affordable Cab Pune", "Reliable Taxi Service Pune"],
  ["Cab Booking Pune", "Local Taxi Service Pune"],
  ["Outstation Cab Pune", "Premium Cab Services Pune"],
  ["Trusted Cab Pune", "24x7 Cab Services Pune"],
  ["Online Cab Booking Pune", "Fast Cab Service Pune"],
  ["Pune Taxi Near Me", "Budget Cab Pune"],
  ["Comfortable Cab Pune", "—"]
],


  "whychoose": [
  {
    "WhyChooseheading": "Best Cab Services in Pune You Can Rely On",
    "WhyChoosedescription": "Aaryan Travels offers dependable and efficient cab services throughout Pune to meet all your travel needs."
  },
  {
    "WhyChooseheading": "Prompt and Convenient Pickup Across Pune",
    "WhyChoosedescription": "Our drivers are strategically located to ensure quick and hassle-free pickups wherever you are in Pune."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Every Ride",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to provide maximum comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Well-Acquainted with Pune Routes",
    "WhyChoosedescription": "Our professional drivers know Pune inside out, ensuring smooth and timely journeys."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent pricing covering fuel, tolls, and driver allowances with no surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Bookings",
    "WhyChoosedescription": "Our support team is available around the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Suit Your Schedule",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point trips, or long-distance travel according to your preferences."
  },
  {
    "WhyChooseheading": "Variety of Vehicle Options for Your Convenience",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and luggage needs."
  }
]
























  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide the best cab services in Pune?',
    answer: 'Yes, Aaryan Travels is known for offering reliable, safe, and comfortable cab services throughout Pune.',
  },
  {
    question: 'How can I book the best cab service in Pune with Aaryan Travels?',
    answer: 'You can book easily via our website, mobile app, or by calling our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available with Aaryan Travels in Pune?',
    answer: 'Aaryan Travels offers a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit all travel needs.',
  },
  {
    question: 'Are Aaryan Travels cabs available for local as well as outstation trips from Pune?',
    answer: 'Yes, we provide both local and outstation cab services from Pune to various destinations.',
  },
  {
    question: 'Are the drivers experienced and familiar with Pune routes?',
    answer: 'Absolutely. Our drivers are licensed, professional, and well-acquainted with Pune and surrounding areas.',
  },
  {
    question: 'Do you offer hourly and daily rental packages for cab services in Pune?',
    answer: 'Yes, Aaryan Travels offers flexible hourly and daily cab rental packages to meet your travel requirements.',
  },
  {
    question: 'What safety and hygiene measures does Aaryan Travels follow in Pune?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Is Aaryan Travels cab service in Pune available 24x7?',
    answer: 'Yes, our cab services are available round the clock throughout Pune.',
  },
  {
    question: 'What payment options are accepted for cab bookings with Aaryan Travels in Pune?',
    answer: 'We accept cash, credit/debit cards, UPI, and popular digital wallets for hassle-free payments.',
  },
  {
    question: 'Can I customize pickup and drop-off locations anywhere within Pune?',
    answer: 'Yes, Aaryan Travels allows complete customization of your pickup and drop points within Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Deshmukh',
    feedback: 'Aaryan Travels provided an excellent cab service in Pune. The ride was comfortable and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'I had a great experience with Aaryan Travels for my outstation trip from Pune. Highly recommend their services!',
    rating: 5,
  },
];














































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Services in Pune",
  "image": "https://aaryantravels.com/assets/images/best-cab-pune.jpg", // replace with your actual image URL
  "description": "Experience the best cab services in Pune with Aaryan Travels. Affordable, reliable, and available 24x7 for local, outstation, and premium cab bookings. Book your comfortable and fast taxi ride online today.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8", // example rating, adjust as needed
    "ratingCount": "5200", // example rating count, adjust as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500", // example price, adjust as per your pricing
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/best-cab-services-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Best Cab Services in Pune | Affordable & Reliable Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Experience the best cab services in Pune with Aaryan Travels. Affordable, reliable, and available 24x7 for local, outstation, and premium cab bookings. Book your comfortable and fast taxi ride online today."
  />
  <meta
    name="keywords"
    content="Best Cab Services in Pune, Top Cab Companies Pune, Affordable Cab Pune, Reliable Taxi Service Pune, Cab Booking Pune, Local Taxi Service Pune, Outstation Cab Pune, Premium Cab Services Pune, Trusted Cab Pune, 24x7 Cab Services Pune, Online Cab Booking Pune, Fast Cab Service Pune, Pune Taxi Near Me, Budget Cab Pune, Comfortable Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinpune;